import '../Commons.css'

export default function GlassBackground() {
    return (
        <div class="glass-background position-absolute top-0 start-0">
            <div class="position-absolute top-0 start-0"></div>
        </div>
    )
}